import { RouterModule, Routes } from '@angular/router';
import { LoginComponent } from './login/login.component';
import { CreatePasswordComponent } from './create-password/create-password.component';
import { ForgotPasswordComponent } from './forgot-password/forgot-password.component';
import { ResetPasswordComponent } from './reset-password/reset-password.component';
const routes: Routes = [
  {
    path: 'login',
    component: LoginComponent,
  },
  {
    path: 'verify-email',
    component: CreatePasswordComponent,
  },
  {
    path: 'forgot-password',
    component: ForgotPasswordComponent,
  },
  {
    path: 'reset-password',
    component: ResetPasswordComponent,
  },
  //   {
  //     path: 'history',
  //     children: [
  //       {
  //         path: '',
  //         component: COMPONENT
  //       }
  //       ,
  //      {
  //       path: 'ticket/:id',
  //       component: COMPONENT,
  //      }
  //     ]
  //   },
];

export const AuthRoutes = RouterModule.forChild(routes);
